import React from 'react'

import { Row, Col } from 'antd'

import { CardCuentaFlex, CardSaldoFlex } from './Cards'

const CardFlex = ({  cardMonto = {}, cards = [] }) => {
  return (
    <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ marginBottom: '30px' }}>
            <CardSaldoFlex {...cardMonto} />
        </Col>

        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Row gutter={[16, 16]}  justify="center">
                {cards.map((cuenta) => (
                    <Col flex="0 0 370px" >
                        <CardCuentaFlex cuenta={cuenta} />
                    </Col>
                ))}
            </Row>
        </Col>
    </Row>
  )
}

export default CardFlex